import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
/**
 * Matches bold text via `**` as input.
 */

var starInputRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */

var starPasteRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */

var underscoreInputRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */

var underscorePasteRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */

var Bold = Mark.create({
  name: 'bold',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    var _this = this;

    return [{
      tag: 'strong'
    }, {
      tag: 'b',
      getAttrs: function getAttrs(node) {
        return node.style.fontWeight !== 'normal' && null;
      }
    }, {
      style: 'font-weight=400',
      clearMark: function clearMark(mark) {
        return mark.type.name === _this.name;
      }
    }, {
      style: 'font-weight',
      getAttrs: function getAttrs(value) {
        return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['strong', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      setBold: function setBold() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this2.name);
        };
      },
      toggleBold: function toggleBold() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this2.name);
        };
      },
      unsetBold: function unsetBold() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this2.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      'Mod-b': function ModB() {
        return _this3.editor.commands.toggleBold();
      },
      'Mod-B': function ModB() {
        return _this3.editor.commands.toggleBold();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: starInputRegex,
      type: this.type
    }), markInputRule({
      find: underscoreInputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: starPasteRegex,
      type: this.type
    }), markPasteRule({
      find: underscorePasteRegex,
      type: this.type
    })];
  }
});
export { Bold, Bold as default, starInputRegex, starPasteRegex, underscoreInputRegex, underscorePasteRegex };